import { usePriceLineStyles } from './PriceLine.styles';
import { IPriceLineProps } from './PriceLine.types';

const PriceLine = (props: IPriceLineProps) => {
    const { title, monthlyPrice, todayPrice } = props;

    const styles = usePriceLineStyles();

    const monthlyPriceFormatted =
        monthlyPrice != undefined ? `$${(Math.round(monthlyPrice * 100) / 100).toFixed(2)}` : '--';

    const todayPriceFormatted =
        todayPrice != undefined ? `$${(Math.round(todayPrice * 100) / 100).toFixed(2)}` : '--';

    return (
        <div className={styles.root}>
            <div className={styles.title}>{title}</div>

            <div className={styles.pricingContainer}>
                <div className={styles.pricingItem}>{monthlyPriceFormatted}</div>
                <div className={styles.pricingItem}>{todayPriceFormatted}</div>
            </div>
        </div>
    );
};

export default PriceLine;
